import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Section = styled('section')`
  ${media.mdUp`
    margin-left: ${({ theme }) => theme.x4spacePx}px;
  `}

  div {
    &:nth-child(1) {
      float: left;
      margin-right: ${({ theme }) => theme.x7spacePx}px;
    }
    p {
      ${({ theme }) => theme.typography.xSmall}
      margin: 0;
      &:nth-child(1) {
        opacity: 0.5;
      }
    }
  }
`;

export const Data = styled('span')`
  ${({ theme }) => theme.typography.smallStrong}
`;

export const Table = styled('table')`
  margin-top: ${({ theme }) => theme.x4spacePx}px;
  ${({ theme }) => theme.typography.smallStrong}
  width: 100%;
  border-spacing: 0;
  td {
    height: 38px;
    padding-bottom: 8px;
    vertical-align: bottom;
    border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
    &:nth-child(1) {
      opacity: 0.7;
    }
    &:nth-child(2) {
      text-align: right;
    }
  }
`;
